import { CampaignDocument } from '../../model/campaign'
import { campaignAttachmentFileLink } from '../attachments'

// File rows only — link entries come from their own procedures and are mapped
// by mapLinkFromRawData.
export const mapDocumentFromRawData = (rawData: any): CampaignDocument => ({
  entryId: rawData.EntryId,
  campaignId: rawData.CampaignId,
  fileName: rawData.FileName,
  fileLink: campaignAttachmentFileLink(rawData.UID, rawData.FileName.split('.').pop()),
  fileType: rawData.FileType,
  file: rawData.File, // Assuming rawData.File is a Blob
  countries: rawData.Countries && rawData.Countries.length ? rawData.Countries.split(',') : [],
  isVisible: rawData.IsVisible,
  created: rawData.Created,
  createdBy: rawData.CreatedBy,
  modified: rawData.Modified,
  modifiedBy: rawData.ModifiedBy,
})
